module.exports = __webpack_public_path__ + "static/media/dummyProduct.16317bfa.svg";